'use client';

import { useEffect } from 'react';
import { useScriptLoader, ConsentCategory } from 'cookiebanner-finally';

export default function ScriptLoaderConsent() {
  const { register, load } = useScriptLoader();

  useEffect(() => {
    // -----------------------------
    // 1) GOOGLE CONSENT MODE (DEFAULT: DENIED)
    // -----------------------------
    register({
      id: 'gtag-consent-default',
      category: ConsentCategory.Necessary,
      content: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('consent', 'default', {
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          analytics_storage: 'denied'
        });
      `,
    });

    // -----------------------------
    // 2) GOOGLE TAG MANAGER -> only with Analytics
    // -----------------------------
    register({
      id: 'gtm',
      category: ConsentCategory.Analytics,
      content: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NJDNGFMH');`,
    });

    // When marketing consent is granted, update consent mode
    register({
      id: 'gtag-consent-granted-marketing',
      category: ConsentCategory.Marketing,
      content: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('consent', 'update', {
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
        });
      `,
    });

    // When analytics consent is granted, update analytics storage
    register({
      id: 'gtag-consent-granted-analytics',
      category: ConsentCategory.Analytics,
      content: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('consent', 'update', {
          analytics_storage: 'granted',
        });
      `,
    });

    // -----------------------------
    // 3) KLAVIYO -> only with Marketing
    // -----------------------------
    register({
      id: 'klaviyo',
      category: ConsentCategory.Marketing,
      src: 'https://static.klaviyo.com/onsite/js/V5KyP9/klaviyo.js',
    });

    // -----------------------------
    // 4) PROFITWELL -> only with Analytics
    // -----------------------------
    register({
      id: 'profitwell',
      category: ConsentCategory.Analytics,
      content: `(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
        a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
        s.querySelector('meta[name="profitwell-auth"]')?.getAttribute('content');
        m.parentNode.insertBefore(a,m)})(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');`,
    });

    // -----------------------------
    // 5) INTERCOM -> only with Marketing
    // -----------------------------
    register({
      id: 'intercom',
      category: ConsentCategory.Marketing,
      content: `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){
        ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;
        var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};
        w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';
        s.async=true;s.src='https://widget.intercom.io/widget/' +
        d.querySelector('meta[name="intercom-app-id"]')?.getAttribute('content');
        var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};
        if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}
        else{w.addEventListener('load',l,false);}}})();`,
    });

    // -----------------------------
    // 6) Load order
    // -----------------------------
    // Always first: default consent
    load('gtag-consent-default');

    // Analytics (if/when user consents)
    load('gtm').then((loaded) => {
      if (loaded) {
        load('gtag-consent-granted-analytics');
      }
    });

    // Marketing (if/when user consents)
    load('gtag-consent-granted-marketing');
    load('klaviyo');
    load('intercom');

    // Analytics (if/when user consents)
    load('profitwell');
  }, [register, load]);

  return null;
}
